const constants = {
  EMAIL_ID: 'emailID',
};

export default constants;
